import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const UsuarioEnviarReporteService = {
	Listar: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Usuario_Enviar_Reporte_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			id_usuario_enviar_reporte: form.id_usuario_enviar_reporte || null,
			id_empresa: form.id_empresa || null,
			id_cat_tipo_reporte: form.id_cat_tipo_reporte || null,
			id_usuario: form.id_usuario || null,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Usuario_Enviar_Reporte_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_usuario_enviar_reporte: form.id_usuario_enviar_reporte || null,
			id_empresa: form.id_empresa || null,
			id_cat_tipo_reporte: form.id_cat_tipo_reporte || null,
			id_usuario: form.id_usuario || null,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Usuario_Enviar_Reporte_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_usuario_enviar_reporte, id_usuario) => {
		let params = {
			id_usuario_enviar_reporte: id_usuario_enviar_reporte || null,
			id_usuario: id_usuario || null
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Usuario_Enviar_Reporte_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
